import React, { Component } from 'react';
import { connect } from 'react-redux';
import { openCartModal, openUpgradeFlowModal } from '../modules/active_modal';

class IconCartState extends Component {
  render() {
    let oCounter = '';
    let iCountCartItems = 0;
    let {dispatch} = this.props;
    let iconButtonFunction = openCartModal;
    let iconClosedbox = (
      <svg version="1.1" id="Layer_1" x="0px" y="0px" width="33px" height="33px" viewBox="0 0 864 864" enable-background="new 0 0 864 864">
        <polygon fill="#A2B4B8" points="87.167,649.257 389.773,797.805 389.773,414.519 87.167,265.943 "/>
        <polygon fill="#A2B4B8" points="441.136,414.519 441.136,797.805 743.741,649.257 743.741,265.943 "/>
        <polygon fill="#A2B4B8" points="428.294,75.195 133.018,218.259 428.294,361.31 723.571,218.259 "/>
      </svg>
    )

    let iconOpenbox = (
      <svg version="1.1" id="Layer_1" x="0px" y="0px"
         width="33px" height="33px" viewBox="0 0 864 864" enable-background="new 0 0 864 864">
      <g>
        <path fill="#A2B4B8" d="M256.033,591.515l-127.876-78.888V638.41l274.967,159.868V435.895L256.033,591.515z M462.796,798.278
          L737.763,638.41V512.627l-127.876,78.888l-149.214-155.62v362.384H462.796z M490.509,414.587l125.783,132.157l228.07-140.686
          L720.735,282.416L490.509,414.587z M23.681,406.059l228.071,140.686l125.784-132.157L147.34,282.416L23.681,406.059z
           M17.309,199.279l130.031,59.689l249.379-140.686L243.254,75.652L17.309,199.279z M469.201,118.283L718.58,258.968l130.031-59.689
          L624.789,75.652L469.201,118.283z"/>
      </g>
      </svg>
    )

    if ( this.props.customer && this.props.customer.cart ) {
      this.props.customer.cart.forEach(oItem => oItem ? iCountCartItems += oItem.quantity : iCountCartItems = iCountCartItems);
    }

    if ( this.props.customer.fulfillment_type == "Positive"  && this.props.upgradeStatus ){
      iconButtonFunction = openUpgradeFlowModal;
      iCountCartItems = 0;
      this.props.computedCart.items.forEach(oItem => oItem ? iCountCartItems += oItem.quantity : iCountCartItems = iCountCartItems);
    }

    if (iCountCartItems > 0) {
      oCounter = oCounter = <span className="round-counter">{iCountCartItems}</span>;
    }

    let sBoxIcon = iCountCartItems >= 12
      ? iconClosedbox
      : iconOpenbox;
    return (
      <span className="icon-holder box unselectable" onClick={() => dispatch( iconButtonFunction() )}>
        {oCounter}
        {sBoxIcon}
        <div className="menu-nav-text">My Box</div>
      </span>
    );
  }
};

function mapStateToProps(state){
    return {
      'customer': state.customer,
      'computedCart': state.computedCart,
      'upgradeStatus': state.upgradeStatus,
      'storeType': state.store.type
    };
}

export default connect(mapStateToProps)(IconCartState);


// WEBPACK FOOTER //
// ./src/components/IconCartState.jsx